import Weather from './component/Weather';
import './App.css';

function App() {
  return (
    <div>
      <Weather></Weather>
    </div>
  );
}

export default App;
